export default function LetterInputList({
  prompt,
  letters = [],
  legend = [],
  items = [],
  value = {},
  onChange,
  mode = "edit",
  feedback
}) {
  const isReview = mode === "review";

  function setAnswer(id, v) {
    if (mode !== "edit") return;

    const raw = v
      .toUpperCase()
      .replace(/[^A-Z]/g, "")
      .slice(0, 2);

    if (letters.length && raw) {
      const isValidPrefix = letters.some(l => l.startsWith(raw));
      if (!isValidPrefix) return;
    }

    onChange({
      ...value,
      [id]: raw
    });
  }

  let questionNumber = 0;

  return (
    <div style={{ display: "grid", gap: 16 }}>
      {/* Prompt */}
      {prompt && (
        <div style={{ fontWeight: 600 }}>
          {prompt}
        </div>
      )}

      {/* Legend */}
      {legend.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 16,
            fontSize: 14,
            padding: "6px 10px",
            border: "1px solid #ccc",
            borderRadius: 6,
            background: "#f9f9f9",
            flexWrap: "wrap"
          }}
        >
          {legend.map((text, i) => (
            <span key={i}>{text}</span>
          ))}
        </div>
      )}

      {/* Items */}
      <div style={{ display: "grid", gap: 10 }}>
        {items.map((item, i) => {
          if (item.type === "heading") {
            return (
              <div
                key={`heading-${i}`}
                style={{
                  marginTop: i === 0 ? 0 : 14,
                  fontWeight: 700,
                  letterSpacing: 0.5,
                  textTransform: "uppercase"
                }}
              >
                {item.label}
              </div>
            );
          }

          questionNumber += 1;

          const fb = feedback?.parts?.[item.id];

          const border =
            !isReview
              ? "2px solid #333"
              : fb?.correct
              ? "2px solid #2e7d32"
              : "2px solid #c62828";

          return (
            <div
              key={item.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                lineHeight: 1.6
              }}
            >
              <strong style={{ width: 24, textAlign: "right" }}>
                {questionNumber}.
              </strong>

              <input
                type="text"
                maxLength={2}
                value={value[item.id] || ""}
                disabled={isReview}
                onChange={(e) =>
                  setAnswer(item.id, e.target.value)
                }
                style={{
                  width: 36,
                  height: 36,
                  textAlign: "center",
                  fontSize: 16,
                  border,
                  borderRadius: 6
                }}
              />

              <span style={{ fontSize: 15 }}>
                {item.label}
              </span>

              {/* {isReview && !fb?.correct && fb?.expected && (
                <span
                  style={{
                    fontSize: 12,
                    color: "#c62828",
                    marginLeft: 8
                  }}
                >
                  (Correct: {fb.expected})
                </span>
              )} */}
            </div>
          );
        })}
      </div>
    </div>
  );
}
